import { Link } from "react-router-dom";
import { Phone, MapPin, Star } from "lucide-react";
import { NAV } from "@/data/nav";
import { SITE, ADDRESS_LINE } from "@/data/site";

const LVP_COL = {
  label: "LVP Flooring",
  items: [
    { label: "Luxury Vinyl Plank", href: "/flooring/luxury-vinyl-plank" },
    { label: "Products & Prices", href: "/products" },
    { label: "LVP Installation", href: "/installation" },
    { label: "For Homeowners", href: "/homeowners" },
    { label: "Free Estimate", href: "/free-estimate" },
  ],
};
const cols = [LVP_COL, ...["contractors", "areas"].map((k) => NAV.find((n) => n.mega === k))];

export const Footer = () => (
  <footer className="bg-[#111] pb-24 text-zinc-300 md:pb-0" data-testid="site-footer">
    <div className="wrap grid gap-12 py-16 lg:grid-cols-[1.3fr_2fr] lg:py-20">
      <div>
        <img src="/img/logo-light-360.webp" alt="Wholesale LVP Flooring" width="360" height="68" loading="lazy" className="h-9 w-auto" />
        <p className="mt-6 max-w-sm leading-relaxed">Quality flooring for 40–50% less than big-box store pricing. Wholesale flooring, professional installation and contractor supply across Lake Norman.</p>
        <address className="mt-8 space-y-3 not-italic">
          <a href={SITE.mapsUrl} target="_blank" rel="noopener noreferrer" className="flex items-start gap-3 hover:text-white" data-testid="footer-address-link">
            <MapPin className="mt-0.5 h-5 w-5 shrink-0 text-[#F2C200]" /> {ADDRESS_LINE}
          </a>
          <a href={`tel:${SITE.tel}`} className="flex items-center gap-3 text-2xl font-extrabold text-white" data-testid="footer-phone-link">
            <Phone className="h-5 w-5 text-[#F2C200]" /> {SITE.phone}
          </a>
        </address>
        <dl className="mt-8 grid max-w-xs grid-cols-2 gap-x-4 gap-y-1 text-sm">
          {SITE.hours.map((h) => (
            <div key={h.d} className="contents">
              <dt className="text-zinc-400">{h.d}</dt>
              <dd>{h.h}</dd>
            </div>
          ))}
        </dl>
        <a href={SITE.mapsUrl} target="_blank" rel="noopener noreferrer" className="mt-8 inline-flex items-center gap-2 rounded-full border border-white/15 px-4 py-2 text-sm hover:border-[#F2C200]" data-testid="footer-google-rating">
          <Star className="h-4 w-4 fill-[#F2C200] text-[#F2C200]" /> {SITE.rating.value} on Google · {SITE.rating.count} reviews
        </a>
      </div>
      <div className="grid grid-cols-2 gap-10 sm:grid-cols-3">
        {cols.map((c) => (
          <div key={c.label}>
            <p className="font-mono text-xs uppercase tracking-[0.18em] text-[#F2C200]">{c.label}</p>
            <ul className="mt-5 space-y-3 text-[15px]">
              {[...c.items, ...(c.audiences || []).slice(0, 2)].map((it) => (
                <li key={it.href}><Link to={it.href} className="hover:text-white">{it.label}</Link></li>
              ))}
            </ul>
          </div>
        ))}
        <div className="col-span-2 sm:col-span-3">
          <ul className="flex flex-wrap gap-x-8 gap-y-3 border-t border-white/10 pt-8 text-[15px] font-semibold text-white">
            {[["Homeowners", "/homeowners"], ["Gallery", "/gallery"], ["About", "/about"], ["FAQ", "/faq"], ["Contact", "/contact"], ["Free Estimate", "/free-estimate"], ["Contractor Pricing", "/contractor-pricing"]].map(([l, h]) => (
              <li key={h}><Link to={h} className="hover:text-[#F2C200]">{l}</Link></li>
            ))}
          </ul>
        </div>
      </div>
    </div>
    <div className="border-t border-white/10">
      <div className="wrap flex flex-col gap-2 py-6 text-sm text-zinc-400 sm:flex-row sm:justify-between">
        <p>© 2026 {SITE.name}. All rights reserved.</p>
        <p>Serving Huntersville · Cornelius · Denver · Sherrills Ford · Iron Station</p>
      </div>
    </div>
  </footer>
);

export const MobileBar = () => (
  <div className="fixed inset-x-0 bottom-0 z-40 grid grid-cols-3 gap-2 border-t border-[#e5e1d8] bg-white/95 p-2 backdrop-blur-xl md:hidden" style={{ paddingBottom: "max(0.5rem, env(safe-area-inset-bottom))" }} data-testid="mobile-action-bar">
    <a href={`tel:${SITE.tel}`} className="flex h-12 items-center justify-center gap-1.5 rounded-xl bg-[#111] text-sm font-bold text-white" data-testid="mobile-bottom-call-btn">
      <Phone className="h-4 w-4 text-[#F2C200]" /> Call
    </a>
    <Link to="/free-estimate" className="flex h-12 items-center justify-center rounded-xl bg-[#F2C200] text-sm font-bold text-[#111]" data-testid="mobile-bottom-estimate-btn">Free Estimate</Link>
    <Link to="/contractor-pricing" className="flex h-12 items-center justify-center rounded-xl border-2 border-[#111] px-1 text-center text-[13px] font-bold leading-tight" data-testid="mobile-bottom-contractor-btn">Contractor Pricing</Link>
  </div>
);
